<div class="app-page">
  <!-- Header -->
  <div class="app-page-header">
    <div class="flex items-center justify-between">
      <div>
        <h1 class="section-title">Gestión de Anunciantes</h1>
        <p class="section-subtitle">
          Administra los anunciantes vinculados a esta agencia/productor
        </p>
      </div>
      <div class="flex gap-2">
        <button 
          pButton 
          type="button"
          label="Volver"
          icon="pi pi-arrow-left"
          class="p-button-outlined"
          (click)="goBack()"
          [disabled]="loading()">
        </button>
        <button 
          pButton 
          type="button"
          label="Vincular anunciante"
          icon="pi pi-link"
          class="p-button"
          (click)="openLinkDialog()"
          [disabled]="loading()">
        </button>
      </div>
    </div>
  </div>

  <!-- Breadcrumb -->
  <div class="breadcrumb-wrapper">
    <p-breadcrumb [model]="breadcrumbItems()"></p-breadcrumb>
  </div>

  <!-- Main Content -->
  <div class="app-page-content">
    <!-- Card: Información de la Agencia/Productor -->
    @if (cliente(); as clienteData) {
      <p-card class="context-card">
        <div class="context-content">
          <div class="context-main">
            <h3 class="context-title">{{ clienteData.razonSocial }}</h3>
            @if (clienteData.nombreFantasia) {
              <p class="context-subtitle">{{ clienteData.nombreFantasia }}</p>
            }
          </div>
          <div class="context-meta">
            <div class="context-chips">
              @for (tipo of clienteData.tipoCliente; track tipo) {
                <p-tag 
                  [value]="getTipoClienteLabel([tipo])" 
                  [severity]="tipo === 'agencia' ? 'info' : tipo === 'productor' ? 'success' : 'warn'"
                  [rounded]="true">
                </p-tag>
              }
              @if (clienteData.active) {
                <p-tag value="Activo" severity="success" [rounded]="true"></p-tag>
              } @else {
                <p-tag value="Inactivo" severity="danger" [rounded]="true"></p-tag>
              }
            </div>
            <div class="context-count">
              <i class="pi pi-users"></i>
              <span>{{ totalRecords() }} anunciante{{ totalRecords() !== 1 ? 's' : '' }}</span>
            </div>
          </div>
        </div>
      </p-card>
    }

    <!-- Card: Tabla de Anunciantes -->
    <div class="app-card">
      <h2 class="text-xl font-semibold mb-4" style="color: hsl(var(--text));">
        Anunciantes Vinculados
      </h2>

      <!-- Buscador Global -->
      <div class="search-wrapper mb-4">
        <span class="p-input-icon-left w-full">
          <i class="pi pi-search"></i>
          <input 
            pInputText 
            type="text" 
            placeholder="Buscar anunciantes..."
            (input)="onGlobalFilter($event)"
            class="w-full" />
        </span>
      </div>

        <!-- Tabla -->
        @if (anunciantes().length > 0 || loading()) {
          <p-table
            #dt
            [value]="anunciantes()"
            [lazy]="true"
            [loading]="loading()"
            [totalRecords]="totalRecords()"
            [rows]="nroFilasPorPagina"
            [rowsPerPageOptions]="[10, 20, 30, 50]"
            [paginator]="true"
            [sortMode]="'multiple'"
            [multiSortMeta]="multiSortMeta"
            (onLazyLoad)="onLazyLoad($event)"
            [globalFilterFields]="['razonSocial', 'nombreFantasia', 'cuit', 'email', 'telefono']"
            styleClass="p-datatable-sm"
            [tableStyle]="{'min-width': '50rem'}">
            
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="razonSocial" style="width: 25%">
                  Razón Social
                  <p-sortIcon field="razonSocial"></p-sortIcon>
                </th>
                <th pSortableColumn="cuit" style="width: 15%">
                  CUIT
                  <p-sortIcon field="cuit"></p-sortIcon>
                </th>
                <th pSortableColumn="email" style="width: 20%">
                  Email
                  <p-sortIcon field="email"></p-sortIcon>
                </th>
                <th pSortableColumn="telefono" style="width: 15%">
                  Teléfono
                  <p-sortIcon field="telefono"></p-sortIcon>
                </th>
                <th pSortableColumn="active" style="width: 10%">
                  Estado
                  <p-sortIcon field="active"></p-sortIcon>
                </th>
                <th style="width: 15%">Acciones</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-anunciante>
              <tr>
                <td>
                  <div class="font-medium" style="color: hsl(var(--text));">{{ anunciante.razonSocial }}</div>
                  @if (anunciante.nombreFantasia) {
                    <div class="text-sm" style="color: hsl(var(--muted));">
                      {{ anunciante.nombreFantasia }}
                    </div>
                  }
                </td>
                <td style="color: hsl(var(--text));">{{ anunciante.cuit || '-' }}</td>
                <td style="color: hsl(var(--text));">{{ anunciante.email || '-' }}</td>
                <td style="color: hsl(var(--text));">{{ anunciante.telefono || '-' }}</td>
                <td>
                  @if (anunciante.active) {
                    <span class="app-badge app-badge-success">
                      <i class="pi pi-check mr-1"></i>
                      Activo
                    </span>
                  } @else {
                    <span class="app-badge app-badge-danger">
                      <i class="pi pi-times mr-1"></i>
                      Inactivo
                    </span>
                  }
                </td>
                <td>
                  <div class="actions-cell">
                    <button 
                      pButton 
                      type="button"
                      icon="pi pi-pencil"
                      class="p-button-text p-button-rounded p-button-sm"
                      pTooltip="Editar"
                      (click)="editAnunciante(anunciante)">
                    </button>
                    <button 
                      pButton 
                      type="button"
                      icon="pi pi-times-circle"
                      class="p-button-text p-button-rounded p-button-sm p-button-danger"
                      pTooltip="Desvincular"
                      (click)="unlinkAnunciante(anunciante)">
                    </button>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="6" class="text-center py-8">
                  <div class="flex flex-col items-center gap-2">
                    <i class="pi pi-inbox text-4xl" style="color: hsl(var(--muted));"></i>
                    <p style="color: hsl(var(--muted));">No hay anunciantes vinculados</p>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
      } @else {
        <!-- Estado vacío -->
        <div class="text-center py-12">
          <div class="flex flex-col items-center gap-4">
            <i class="pi pi-inbox text-6xl" style="color: hsl(var(--muted));"></i>
            <div>
              <h3 class="text-lg font-semibold mb-2" style="color: hsl(var(--text));">
                No hay anunciantes vinculados
              </h3>
              <p class="text-sm mb-4" style="color: hsl(var(--muted));">
                Puede vincular anunciantes existentes o crear nuevos
              </p>
              <div class="flex gap-2 justify-center">
                <button 
                  pButton 
                  type="button"
                  label="Vincular Anunciante"
                  icon="pi pi-link"
                  class="p-button"
                  (click)="openLinkDialog()">
                </button>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>

<!-- Modal: Vincular Anunciante -->
@if (showLinkDialog()) {
  <app-anunciante-link-dialog
    [visible]="showLinkDialog()"
    [padreId]="cliente()?.id?.toString() || ''"
    (visibleChange)="showLinkDialog.set($event)"
    (anuncianteLinked)="onAnuncianteLinked()">
  </app-anunciante-link-dialog>
}

<p-confirmDialog></p-confirmDialog>

